import { useTheme } from "@mui/material/styles";
import { Input, Button, Box, Typography } from "@mui/material";
import Scene from "./Scene";

const HomePage = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "100vh",
        px: 3,
        position: "relative",
        color: isDarkMode ? "#ffffff" : "#000000",
      }}
    >
      {/* Left Section - Text and Buttons */}
      <Box width={{ xs: "100%", md: "40%" }} textAlign="left" p={3}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Instantly Elegant, Effortlessly Digital – Invitations Made Simple!
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "justify", mb: 2 }}>
          Our <b>digital invitation cards</b> offer <b>instant elegance</b> and{" "}
          <b>effortless customization</b>, making <b>event planning stress-free</b>. With{" "}
          <b>professionally designed templates</b>, you can <b>edit, download, and share</b> via{" "}
          <b>email, WhatsApp, or social media</b> in seconds—<b>no printing needed</b>! Perfect for{" "}
          <b>weddings, birthdays, baby showers, and corporate events</b>, our invitations provide a{" "}
          <b>stylish, convenient, and eco-friendly</b> way to invite guests.
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: isDarkMode ? "#8c7ae6" : "#6c5ce7",
              color: "white",
            }}
          >
            Get Yours Now!
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: isDarkMode ? "#7d5fff" : "#aa67ff",
              color: "white",
            }}
          >
            Pricing
          </Button>
        </Box>
      </Box>

      {/* Right Section - Image Mockups */}
      <Box
        width={{ xs: "100%", md: "60%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <img
          src="/assets/mockup2.png"
          alt="Mockup 1"
          style={{ width: "45%", transform: "rotate(-10deg)", marginRight: "-10%" }}
        />
        <img
          src="/assets/mockup1.png"
          alt="Mockup 2"
          style={{ width: "45%", transform: "rotate(10deg)" }}
        />
      </Box>

      {/* Chatbot Icon */}
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 20,
          display: "flex",
          alignItems: "center",
          background: isDarkMode ? "#333" : "#fff",
          p: 1,
          borderRadius: "10px",
          boxShadow: isDarkMode ? "0px 4px 10px rgba(255,255,255,0.1)" : "0px 4px 10px rgba(0,0,0,0.1)",
          cursor: "pointer",
        }}
      ></Box>
    </Box>
  );
};

export default HomePage;
